import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-3xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-6 text-3xl font-black text-foreground-950 md:text-5xl">404</h1>
      <p className="mt-3 text-base font-medium text-foreground-700">抱歉，这个页面还没有生成</p>
      <p className="mt-1 font-mono text-sm text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/news"
          className="whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}